module.exports = __webpack_public_path__ + "img/gw1.7338e796.jpg";